import { render } from "./ChartViewer.vue?vue&type=template&id=0d5621bf"
import script from "./ChartViewer.vue?vue&type=script&lang=js"
export * from "./ChartViewer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__